<template>
  <div class="donationLayout">
    <div class="pl-5 pr-5 pt-5 pb-5 container">
      <div class="quickGiving">
        <h2>Quick Giving Option</h2>
        <p>
          <strong>I want to reach people around the world with the Gospel of Jesus Christ.</strong>
          <br />Give securely by credit card, debit card, PayPal or online check.
        </p>
        <!-- <a-slider
          :marks="marks"
          :step="null"
          :included="false"
          :default-value="50"
          :tooltipVisible="false"
          :vertical="!isDesktop"
          :style="!isDesktop ? 'display: inline-block;height: 300px;marginLeft: 70px' : ''"
          :reverse="!isDesktop"
        />-->
        <div class="donation-container mt-5">
          <div class="content-container">
            <div class="item" v-for="item in donationPrefer" :key="item">
              <a-button :type="item === quickDonation ? 'primary' : 'default'" class="mb-3" @click="quickDonation = item">${{ item }}</a-button>
            </div>
          </div>
          <div class="buttonContainer">
            <a-input size="large" prefix="$" v-model="quickDonation" />
            <div>
              <div class="option">
                <a-radio-group v-model="donationType">
                  <a-radio :style="radioStyle" :value="'onetime'">One-time Gift</a-radio>
                  <a-radio :style="radioStyle" :value="'monthly'">Monthly Gift</a-radio>
                </a-radio-group>
              </div>
              <div class="button">
                <a-button type="primary">Give now</a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 class="mt-5 mb-5">Or Give to Specific Areas</h2>
      <div class="specificGiving">
        <a-row v-for="number in 3" :key="number" class="mt-4">
          <a-col :span="6" class="left">
            <img src="https://static.billygraham.org/sites/billygraham.org/uploads/pro/2013/05/29143207/Donate-Where-Most-Needed.jpg" alt="Where Most Needed" />
          </a-col>
          <a-col :span="18" class="right pl-5 pr-3">
            <h4>
              <a href="https://billygraham.org/donation/where-most-needed/">Where Most Needed</a>
            </h4>
            <p>
              I want to reach the world with the Good News by equipping the Billy Graham Evangelistic Association with resources—including personnel, materials, support services, buildings and more—to
              urgently respond to every opportunity to share Jesus Christ with others.
              <a href="https://billygraham.org/donation/where-most-needed/">More Info</a>
            </p>
            <!-- <a-slider
              :marks="marks"
              :step="null"
              :included="false"
              :tooltipVisible="false"
              :vertical="!isDesktop"
              :style="!isDesktop ? 'display: inline-block;height: 300px;marginLeft: 70px' : ''"
              :reverse="!isDesktop"
            />-->
            <a-input size="large" prefix="$" v-model="specificDonation[number]" @keypress.native="isNumber($event)" />
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { isEmpty, last } from 'lodash';
export default {
  data() {
    return {
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      donationType: 'onetime',
      donationRange: [0, 10, 25, 50, 75, 100, 150, 200, 300, 400, 500],
      donationPrefer: [25, 50, 100, 250],
      quickDonation: 25,
      specificDonation: {},
    };
  },
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    marks() {
      const step = 100 / (this.donationRange.length - 1);
      return this.donationRange.reduce((obj, item, index) => {
        obj[index * step] = `$${item}`;
        return obj;
      }, {});
    },
    lastAmount() {
      return last(this.donationRange);
    },
  },
  methods: {
    isEmpty,
    isNumber(evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss">
.donationLayout {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .container {
    width: 100%;
    margin: auto;
    margin-top: 0;
    h2 {
      text-transform: uppercase;
      font-weight: 700;
    }
    .ant-slider {
      padding: 0;
      &:hover {
        background-color: #fff;
      }
      &-step {
        background: #fff;
        height: 0;
      }
      &-rail {
        height: 10px;
        background: #fff;
      }
      &-dot {
        height: 10px;
        width: 10px;
        top: 0;
        border-color: #007bff;
      }
      &-handle {
        background: #007bff;
        margin-top: -3px;
      }
      &-mark {
        span {
          font-weight: 700;
        }
      }
    }
    .quickGiving {
      padding: 30px;
      background: #ddd;
      border-radius: 10px;
      box-shadow: 0 0 5px #ddd;
      color: #555;
      .donation-container {
        display: flex;
        .content-container {
          flex: 0 1 50%;
          display: flex;
          flex-wrap: wrap;
          .item {
            flex: 0 1 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            button {
              min-width: 80%;
              box-sizing: content-box;
              padding: 5px;
            }
          }
        }
        .buttonContainer {
          flex: 1 1;
          .ant-input-prefix {
            font-weight: 700;
            font-size: 20px;
          }
          > div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .button .ant-btn {
              min-width: 120px;
              text-transform: uppercase;
              font-size: 16px;
              padding: 5px;
              box-sizing: content-box;
            }
            .option {
              .ant-radio-wrapper span {
                font-weight: 700;
              }
            }
          }
        }
      }
    }
    .specificGiving {
      color: #222;
      > div {
        border: 1px solid #ddd;
        padding: 10px;
        border-radius: 5px;
        box-shadow: 0 0 5px #ddd;
        transition: transform 0.3s;
        &:hover {
          transform: scale(1.01);
        }
      }
      .left {
        img {
          width: 100%;
        }
      }
      .right {
        a {
          color: #007bff;
          &:hover {
            color: rgba(#007bff, 0.8);
          }
        }
        p {
          font-size: 18px;
        }
        .ant-slider {
          &:hover {
            background-color: #fff;
          }
          &-rail {
            background: #ddd;
          }
        }
        .ant-input {
          max-width: 100px;
        }
      }
    }
  }
  .fullpage {
    > div {
      max-width: 100%;
    }
  }
}
</style>
